<div class="toast-content" fxLayout="column">
  <div class="header" fxLayout="row">
    <div class="title">{{ title }}</div>
    <div class="icon">
      <mat-icon>warning</mat-icon>
    </div>
  </div>
  <div class="content">
    {{ subtitle }}
  </div>
</div>
